export default (axios) => ({
  getBlogs(params) {
    return axios.get('/blog/public', { params })
  },

  getDetailBlog(blogId) {
    return axios.get(`/blog/public/${blogId}`)
  },

  getRecentBlog(params) {
    return axios.get(`/blog/public/recent`, { params })
  },

  getProductIdBlog(params) {
    return axios.get(`/blog/getProductId`, { params })
  },
  // 获取产品数据
  getByProductId(params) {
    return axios({
      method: 'get',
      url: '/productLanguage/getListByBlogId',
      params
    })
  },
  // 获取最近的 3 条数据
  getBlogData(params) {
    return axios({
      method: 'get',
      url: '/blog/getRecentBlog',
      params
    })
  },
  // 获取blog列表
  getBlogList(params) {
    return axios({
      method: 'get',
      url: '/blog/blogList',
      params
    })
  }
  //
  //
})
